
import { Component, OnInit, Inject} from '@angular/core';
import { DealershipService } from '../services/dealership.service';
import {  Report, UpdateDealership } from '../models/dealership.model';

import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'edit-dealership-modal',
    templateUrl: './edit-dealership-modal.component.html',
    styleUrls: ['./edit-dealership-modal.component.scss']
})
export class EditDealershipModalComponent implements OnInit {
    dealershipName: string = '';
    updatingDealership: boolean = false;
    dropdownList = [];
    dropdownSettings = {};
    ropedropdownSettings={};
    ropedropdownList=[];
    weardropdownSettings={};
    weardropdownList=[];
    wsredropdownSettings={};
    wsredropdownList=[];
    selectedItems :number[] =[];;
    ropeselectedItems :number[] =[];;
    wearselectedItems :number[] =[];
    wsreselectedItems:number[] =[];;
    loadingCurrentDetails: boolean = true;
    dealershipId: number;


    selectedQuoteStyles = [];
    quoteReportSetting = {};
    availableQuoteReportStyles = [];

    address1:string;
    address2:string;
    phone:string;
    suburb:string;
    postCode:string;
    state:string;
    email:string;
    constructor(public dialogRef: MatDialogRef<EditDealershipModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private _dealershipService: DealershipService, public snackBar: MatSnackBar, private _notifications: NotificationsService) { }

    ngOnInit() {
        if (this.data != null) {
            this.dealershipId = this.data.dealershipId;
        }
        // this._dealershipService.getAllReportTypes().subscribe(result => {
        //     result.forEach(r => {
        //         this.dropdownList.push({
        //             "id": r.ReportId,
        //             "itemName": r.ReportName
        //         });
        //     });

        // });




        this.dropdownSettings = {
            singleSelection: false,
            text: "Select Report Styles",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: "multiselect-dropdown",
            maxHeight: 150
        };


        this._dealershipService.getAllRopeShovelReportTypes().subscribe(result => {
            // result.forEach(r => {
            //     this.ropedropdownList.push({
            //         "id": r.ReportId,
            //         "itemName": r.ReportName
            //     });
            // });
            this.ropedropdownList = result;

        });

        this._dealershipService.getAllGetWearReportTypes().subscribe(result => {
            // result.forEach(r => {
            //     this.weardropdownList.push({
            //         "id": r.ReportId,
            //         "itemName": r.ReportName
            //     });
            // });
            this.weardropdownList = result

        });

        this._dealershipService.getAllWsreReportTypes().subscribe(result => {
            // result.forEach(r => {
            //     this.wsredropdownList.push({
            //         "id": r.ReportId,
            //         "itemName": r.ReportName
            //     });
            // });
            this.wsredropdownList = result

        });


        this.ropedropdownSettings = {
            singleSelection: false,
            text: "Select Report Styles",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: "multiselect-dropdown",
            maxHeight: 150
        };

        this.weardropdownSettings = {
            singleSelection: false,
            text: "Select Report Styles",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: "multiselect-dropdown",
            maxHeight: 150
        };

        this.wsredropdownSettings = {
            singleSelection: false,
            text: "Select Report Styles",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: "multiselect-dropdown",
            maxHeight: 150
        };
        //AllQuoteReportStyles
        this._dealershipService.getAllQuoteReportStyles().subscribe(result => {
            console.log(result);
            // result.forEach(r => {
            //     this.availableQuoteReportStyles.push({
            //         "id": r.ReportId,
            //         "itemName": r.ReportName
            //     });
            // });
            this.availableQuoteReportStyles = result;
            this.loadDealershipDetails();
        });




        this.quoteReportSetting = {
            singleSelection: false,
            text: "Select Quote Report Styles",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: "multiselect-dropdown",
            maxHeight: 150
        };

    }

    onNoClick(): void {
        this.dialogRef.close();
    }
    Validate(event:any) {
        var regex = new RegExp("^[0-9-()+ ]");
        var key = String.fromCharCode(event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
    } 
    loadDealershipDetails() {
        this._dealershipService.getDealershipDetails(this.dealershipId).subscribe(dealership => {
            this.dealershipName = dealership.DealershipName;
            this.phone = dealership.phone;
            this.address1=dealership.address1;
            this.address2=dealership.address2;
            this.suburb=dealership.suburb;
            this.postCode=dealership.postcode;
            this.state=dealership.state;
            this.email=dealership.email;

            this._dealershipService.getAllReportTypesByDealerGroupId(dealership.DealerGroupId).subscribe(result => {
                // result.forEach(r => {
                //     this.dropdownList.push({
                //         "id": r.ReportId,
                //         "itemName": r.ReportName
                //     });
                // });
                this.dropdownList = result;
            });

            
            this.selectedItems = dealership.ReportStyles.map(x=>x.ReportId);
            this.ropeselectedItems = dealership.RopeReportStyles.map(x=>x.ReportId);
            this.wearselectedItems = dealership.WearReportStyles.map(x=>x.ReportId);
            this.selectedQuoteStyles = dealership.QuoteReportStyles.map(x=>x.ReportId);

            // dealership.ReportStyles.forEach(r => {
            //     this.selectedItems.push(r.ReportId
            //         // "id": r.ReportId,
            //         // "itemName": r.ReportName
            //     );
            // });

            // dealership.RopeReportStyles.forEach(r => {
            //     this.ropeselectedItems.push( r.ReportId
            //     //     {
            //     //     "id": r.ReportId,
            //     //     "itemName": r.ReportName
            //     // }
            // );
            // });


            // dealership.WearReportStyles.forEach(r => {
            //     this.wearselectedItems.push( r.ReportId
            //     //     {
            //     //     "id": r.ReportId,
            //     //     "itemName": r.ReportName
            //     // }
            // );
            // });

            // dealership.WsreReportStyles.forEach(r => {
            //     this.wsreselectedItems.push( r.ReportId
                    
            //     //     {
            //     //     "id": r.ReportId,
            //     //     "itemName": r.ReportName
            //     // }
            // );
            // });
                // dealership.QuoteReportStyles.forEach(r=> {
                //     this.selectedQuoteStyles.push(  r.ReportId
                //     //     {
                //     //     "id": q.ReportId,
                //     //     "itemName": q.ReportName,
                //     // }
                // )
                // } )

            this.loadingCurrentDetails = false;
        });
    }

    updateDealership() {
        if (this.updatingDealership)
            return;
        if (this.dealershipName.length < 1 || this.selectedItems.length < 1) {
            this.snackBar.open('Please fill in all required fields (*)', '', {
                duration: 1500,
            });
            return;
        }
        this.updatingDealership = true;
        let reportStyles: any[] = [];

        this.selectedItems.forEach(i => {
            reportStyles.push({
                ReportId: i,
               // ReportName: i.ReportName
            });
        });


        let ropereportStyles: any[] = [];

        this.ropeselectedItems.forEach(i => {
            ropereportStyles.push({
                ReportId: i,
               // ReportName: i.ReportName
            });
        });

        let wearreportStyles: any[] = [];

        this.wearselectedItems.forEach(i => {
            wearreportStyles.push({
                ReportId: i,
                //ReportName: i.ReportName
            });
        });

        let wsrereportStyles: any[] = [];

        this.wsreselectedItems.forEach(i => {
            wsrereportStyles.push({
                ReportId: i,
                //ReportName: i.ReportName
            });
        });


        let quoteReportStyles: Report[] = [];


        this.selectedQuoteStyles.forEach(s => {
            quoteReportStyles.push({
                ReportId:s,
                ReportName: s.ReportName
            });

        })
        let newDealership: UpdateDealership = {
            DealershipId: this.dealershipId,
            DealershipName: this.dealershipName,
            ReportStyles: reportStyles,
            QuoteReportStyles: quoteReportStyles,
            DealerGroupId: -1,
            RopeReportStyles:ropereportStyles,
            WearReportStyles:wearreportStyles,
            WsreReportStyles:wsrereportStyles,
            phone:this.phone,
            address1:this.address1,
            address2:this.address2,
            suburb:this.suburb,
            postcode:this.postCode,
            state:this.state,
            email:this.email
        }
        this._dealershipService.updateDealership(newDealership).subscribe(result => {
            this.updatingDealership = false;
            if (result.m_Item1 > 0) {
                this._notifications.success('Dealership Updated', 'This dealership has been updated successfully. ');
                this.dialogRef.close(true);
            } else {
                this._notifications.error('Failed', result.m_Item2);
            }
        });
    }
}
